interface DesignIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const DesignIcon = (props: DesignIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path
        style={{ fill: fillColor }}
        d="M27,12.3H13c-0.9,0-1.5,0.7-1.5,1.5v10.1c0,0.9,0.7,1.5,1.5,1.5h5.4V27h-0.8c-0.2,0-0.4,0.2-0.4,0.4
            c0,0.2,0.2,0.4,0.4,0.4h4.6c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-0.8v-1.5H27c0.9,0,1.5-0.7,1.5-1.5V13.8
            C28.5,12.9,27.8,12.3,27,12.3z M20.8,27h-1.5v-1.5h1.5V27z M27.7,23.9c0,0.4-0.3,0.8-0.8,0.8H13c-0.4,0-0.8-0.3-0.8-0.8v-0.8h15.5
            V23.9z M27.7,22.3H12.3v-8.5c0-0.4,0.3-0.8,0.8-0.8H27c0.4,0,0.8,0.3,0.8,0.8L27.7,22.3L27.7,22.3z"
      />
    </svg>
  )
}

export default DesignIcon
